/**
 * Analytics Consent Service
 *
 * Центральный сервис для управления согласием пользователя
 * на необязательные аналитические и маркетинговые cookies.
 *
 * Хранение: localStorage (ключ: analyticsConsent)
 * Значения: 'accepted' | 'declined'
 *
 * Методы:
 *   hasDecision() — принимал ли пользователь решение
 *   isAccepted()  — дал ли пользователь согласие
 *   accept()      — сохранить согласие
 *   decline()     — сохранить отказ
 */

const STORAGE_KEY = 'analyticsConsent'

export const analyticsConsent = {
  /**
   * Проверить, принял ли пользователь какое-либо решение.
   * @returns {boolean}
   */
  hasDecision() {
    const value = localStorage.getItem(STORAGE_KEY)
    return value === 'accepted' || value === 'declined'
  },

  /**
   * Проверить, дал ли пользователь согласие.
   * @returns {boolean}
   */
  isAccepted() {
    return localStorage.getItem(STORAGE_KEY) === 'accepted'
  },

  /**
   * Сохранить согласие пользователя.
   */
  accept() {
    localStorage.setItem(STORAGE_KEY, 'accepted')
  },

  /**
   * Сохранить отказ пользователя.
   */
  decline() {
    localStorage.setItem(STORAGE_KEY, 'declined')
  },
}
